import React from 'react';

import {
    Table,
    Row,
    Col,
    Button,
} from 'antd';

const STATUS = {
    CLOSED: 'CLOSED',
    INPROGRESS: 'IN PROGRESS',
    OPEN: 'OPEN'
}

class Summary extends React.Component {

    constructor(props) {
        super(props)
        let summary = {}

        this.props.allBugs
        .map(_bug => {
            // initialize type summary if not defined
            if (!summary[_bug.type]) {
                summary[_bug.type] = {
                    type: _bug.type,
                    open: 0,
                    inProgress: 0,
                }
            }

            if (_bug.status == STATUS.INPROGRESS) {
                summary[_bug.type].inProgress += 1
            }
            if (_bug.status == STATUS.OPEN) {
                summary[_bug.type].open += 1
            }
        })

        summary = Object.values(summary)
        .filter(_summary => _summary.type != undefined)

        let leaderboard = {}

        this.props.allBugs
        .map(_bug => {
            // initialize name if not defined
            if (!leaderboard[_bug.agent && _bug.agent.name]) {
                leaderboard[_bug.agent && _bug.agent.name] = {
                    name: _bug.agent && _bug.agent.name,
                    count: 0,
                }
            }

            if (_bug.status == STATUS.CLOSED) {
                leaderboard[_bug.agent && _bug.agent.name].count += 1
            }
        })

        leaderboard = Object.values(leaderboard)
        .filter(_leaderboard => _leaderboard.name != undefined)

        this.state = {
            summary: Object.values(summary),
            leaderboard: Object.values(leaderboard),
            showLeaderboard: false,
        }
    }

    render() {

        const columns = [{
            title: 'Type',
            dataIndex: 'type'
        }, {
            title: 'Open',
            dataIndex: 'open'
        }, {
            title: 'In Progress',
            dataIndex: 'inProgress'
        }
        ]

        const columnsLeadeboard = [{
            title: 'Name',
            dataIndex: 'name'
        }, {
            title: 'Closed',
            dataIndex: 'count',
            sorter: (a, b) => a.count - b.count,
            defaultSortOrder: 'descend',
        }
        ]

        return(
                <Row gutter={24}>
                    <Col span={10}>
                        <Table
                        dataSource={this.state.summary}
                        columns={columns}
                        pagination={false}
                        size="small"
                        />
                    </Col>

                    <Col span={8}>
                        {this.state.showLeaderboard && 
                        <div>
                            <Table
                            dataSource={this.state.leaderboard}
                            columns={columnsLeadeboard}
                            pagination={false}
                            size="small"
                            />
                        </div>
                        }
                    </Col>

                    <Col span={4}>
                        <Button onClick={() => this.setState({showLeaderboard: !this.state.showLeaderboard}) }>
                            {this.state.showLeaderboard ? 'Hide Champions' : 'Show Champions'}
                        </Button>
                    </Col>

                </Row>
        )
    }

}

export default Summary;


// WEBPACK FOOTER //
// ./src/components/bug-report/summary.js